module.exports = __webpack_public_path__ + "lv.aa977712b3fd53a9fbf2.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/lv.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/lv.svg
// module chunks = styles